import { userHasPermission } from './../commons/utils/helpers';
// NATIVE 


// INSTALLED 

// CUSTOM 
import { useDispatch } from "react-redux";
import { AxiosAdapter } from "../commons/adapters";
import { closeSessionGlobal } from "../commons/utils";


const http = new AxiosAdapter();



export const getAllUsersPermissionsService = async() => {
   
    try {

        return await http.get<any>(`/v1/user-permissions`); 

    } catch (error:any) {
        console.log('getAllNovedadesTurnoService ',error);

        if( error &&  !error.ok ){
            
            return error;

        }
        console.log('getAllNovedadesTurnoService ',error);
    }
}



export const getNovedadesTurnoDataCreateService = async() => {
   
    try {

        return await http.get<any>(`/v1/user-permissions/data-create-form-inputs`); 

    } catch (error:any) {


        if( error &&  !error.ok ){
            
            return error;

        }
        console.log('getNovedadesTurnoDataCreateService ',error);
    }
}




export const createNovedadesTurnoService = async(tipoNovedad:object, setPercentajeCreateTurno:any) => {
   
    try {

        return await http.post<any>(`/v1/user-permissions`, tipoNovedad, setPercentajeCreateTurno); 

    } catch (error:any) {

        if( error &&  !error.ok ){
            
            return error;

        }
        console.log('createTipoNovedadService ',error);
    }
}





export const convertToUserSystemService = async(tipoNovedad:object, setPercentajeCreateTurno:any) => {
   
    try {

        
        return await http.post<any>(`/v1/user-permissions/convert-user`, tipoNovedad, setPercentajeCreateTurno); 

    } catch (error:any) {

        if( error &&  !error.ok ){
            
            return error;

        }
        console.log('createTipoNovedadService ',error);
    }
}




export const desactiveUserPermissionService = async(userPermissionId: string) => {
   
    try {

        return await http.delete<any>(`/v1/user-permissions/${userPermissionId}`); 

    } catch (error:any) {

        if( error &&  !error.ok ){
            
            return error;

        }
        console.log('desactiveNovedadesTurnoService ',error);
    }
}



export const activeUserPermission = async(userPermissionId: string) => {
   
    try {

        return await http.patch<any>(`/v1/user-permissions/${userPermissionId}`); 

    } catch (error:any) {

        if( error &&  !error.ok ){
            
            return error;

        }
        console.log('activeUserPermission ',error);
    }
}



export const getUserPermissionsDetailService = async(userPermissionId:string) => {
   
    try {

        
        return await http.get<any>(`/v1/user-permissions/${userPermissionId}`); 

    } catch (error:any) {

        if( error &&  !error.ok ){
            
            return error;

        }
        console.log('getUserPermissionsDetailService ',error);
    }
}



export const getNovedadTurnoDetailEditService = async(novedadadesTurnoId:string) => {
   
    try {

        return await http.get<any>(`/v1/user-permissions/edit/${novedadadesTurnoId}`); 

    } catch (error:any) {

        if( error &&  !error.ok ){
            
            return error;

        }
        console.log('getNovedadTurnoDetailEditService ',error);
    }
}



export const getAllTipoNovedadesByPaginateService = async(page:number) => {
   
    try {

        return await http.get<any>(`/v1/user-permissions?page=${page}&take=10`); 

    } catch (error:any) {

        if( error &&  !error.ok ){
            
            return error;

        }
        console.log('getAllTipoNovedadesByPaginateService ',error);
    }
}


export const updateUserPemissionsService = async(userPemission: object) => {
   
    try {

        return await http.put<any>(`/v1/user-permissions`, userPemission); 

    } catch (error:any) {
        
        if( error &&  !error.ok ){
            
            return error;

        }
        console.log('updateUserPemissionsService ',error);

    }
}